import CertsListReassign from './CertsListReassign';

export default CertsListReassign;
